module.exports = __webpack_public_path__ + "img/4w.401a955f.svg";